import { ILifeInsurance } from "@base/modules/patientInsurance/lifeInsurance.interface";
import diamondFront from "@base/assets/images/insuranceCards/card-diamond-front.jpg";
import diamondBack from "@base/assets/images/insuranceCards/card-diamond-back.jpg";
import diamondPlusFront from "@base/assets/images/insuranceCards/card-diamond-plus-front.jpg";
import diamondPlusBack from "@base/assets/images/insuranceCards/card-diamond-plus-back.jpg";

export interface ICardTemplate {
  front: string;
  back: string;
}

/**
 * A plan only gets a member card when the backend asks for one (`show_card`) and its `name` names
 * one of these templates - anything else is listed as plain text, the same as on mobile.
 */
const CARD_TEMPLATES: Record<string, ICardTemplate> = {
  Diamond: { front: diamondFront, back: diamondBack },
  "Diamond Plus": { front: diamondPlusFront, back: diamondPlusBack },
};

export const getCardTemplate = (insurance: ILifeInsurance): ICardTemplate | undefined => {
  if (!insurance.show_card) {
    return undefined;
  }

  return CARD_TEMPLATES[(insurance.name ?? "").trim()];
};
